import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("nic_front_authToken");
  const navigate = useNavigate();
  const userSite = useSelector((state) => state?.switchSiteData?.data?.data);

  useEffect(() => {
    if (!token && !userSite) {
      navigate("/");
    }
  }, [token, userSite]);

  return children;
};

export default PrivateRoute;
